import { BookingMenu, MenuStatus } from "types/menu";
import { WebBooking } from "types/web-booking";
import { hasBookingPassed } from "utils/booking";

/**
 * Returns the menu a guest should respond to for a menu proposal booking.
 * Only future unanswered (Sent) menus are editable.
 * Confirmed menus have already been answered, and passed bookings can no longer be changed.
 */
export function getMenuProposalResponseMenu(booking?: WebBooking | null): BookingMenu | undefined {
    if (!booking || hasBookingPassed(booking)) {
        return undefined;
    }

    return booking?.menus?.find((menu) => menu.status === MenuStatus.Sent);
}
